export const Types = {
  SET_AUTH: "auth/set_auth",
  SET_TOKEN: "auth/set_token",
  SET_ADMIN: "auth/set_admin",
  SET_ONE_FACTOR: "auth/set_one_factor",
};

export const setAuth = (isAuth) => ({
  type: Types.SET_AUTH,
  payload: {
    isAuth,
  },
});

export const setToken = (token) => ({
  type: Types.SET_TOKEN,
  payload: {
    token,
  },
});

export const setIsAdmin = (isAdmin) => ({
  type: Types.SET_ADMIN,
  payload: {
    isAdmin,
  },
});

export const setIsOneFactor = (isOneFactor) => ({
  type: Types.SET_ONE_FACTOR,
  payload: {
    isOneFactor,
  },
});
